import React, { FC, ReactElement } from 'react';

import i18n from '@/content';

import { SettingType, BasePolicySettingProps } from './interfaces';
import getSettingContent from './getSettingContent';
import styles from './PolicySetting.module.scss';

export type { PolicyRowProps, SettingType } from './interfaces';

interface PolicySettingProps extends BasePolicySettingProps {
    hideDescription?: boolean;
    type: SettingType;
    children: ReactElement;
    bottomContent?: ReactElement;
}

const PolicySetting: FC<PolicySettingProps> = ({
    type,
    isChild,
    settingId,
    bottomContent,
    children,
    hideDescription = false,
}) => {
    const {
        titleKey,
        explainKey,
        wrapperClasses: className,
    } = getSettingContent(settingId, type, isChild);

    const showDescription = i18n.exists(titleKey) && !hideDescription;
    const showExplanation = i18n.exists(explainKey) && !isChild;

    return (
        <>
            {showExplanation && (
                <div className={styles.explainText}>
                    {i18n.t(explainKey)}
                </div>
            )}
            <div className={className}>
                {showDescription && (
                    <span className={styles.description} data-testid="policyEditor_settingLine">
                        {i18n.t(titleKey)}
                    </span>
                )}
                <div className={styles.controlWrapper}>
                    {children}
                </div>
            </div>
            {bottomContent}
        </>
    );
};

export default PolicySetting;
